/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { FormattedMessage, type MessageDescriptor } from 'react-intl-next';

import { jsx } from '@atlaskit/css';
import Link from '@atlaskit/link';
import { Box, Text } from '@atlaskit/primitives/compiled';

import { messages } from './messages';

// to remove free after STARB-1521
type Edition = 'free' | 'standard' | 'premium';

const URLS = {
	TERMS: 'https://www.atlassian.com/legal/customer-agreement',
	PRIVACY: 'https://www.atlassian.com/legal/privacy-policy',
} as const;

export const LegalText = ({
	ctaText,
	edition,
	hasPaymentDetails,
}: {
	ctaText: MessageDescriptor;
	edition: Edition;
	hasPaymentDetails: boolean;
}): JSX.Element => {
	const noPaymentDetailsLegalText =
		edition === 'premium'
			? messages.noPaymentDetailsLegalTextPremium
			: messages.noPaymentDetailsLegalTextStandard;
	const legalText = hasPaymentDetails
		? messages.paymentDetailsLegalText
		: noPaymentDetailsLegalText;

	return (
		<Box>
			<Text size="small" weight="regular" color="color.text.subtlest" testId="legal-text">
				<FormattedMessage
					{...legalText}
					values={{
						cta: <FormattedMessage {...ctaText}></FormattedMessage>,
						tc: (chunks) => (
							<Link href={URLS.TERMS} target="_blank">
								{chunks}
							</Link>
						),
						pp: (chunks) => (
							<Link href={URLS.PRIVACY} target="_blank">
								{chunks}
							</Link>
						),
						br: <br />,
					}}
				/>
			</Text>
		</Box>
	);
};
